/**
 * openPdfInNewTab — open a blank tab synchronously inside the click handler
 * (so popup blockers allow it), then point it at the PDF once the server
 * returns the URL. Falls back to same-tab navigation when the popup was
 * blocked anyway.
 *
 *   const tab = openPdfInNewTab();
 *   try { tab.show(url); } catch { tab.close(); }
 */
export const openPdfInNewTab = () => {
  let win = null;
  try {
    win = window.open("", "_blank");
    if (win) {
      win.document.title = "מכין קובץ להדפסה…";
      win.document.body.style.cssText = "font-family:Arial,sans-serif;direction:rtl;padding:32px;color:#334155";
      win.document.body.textContent = "מכין קובץ להדפסה…";
    }
  } catch {
    win = null;
  }
  return {
    show(url) {
      if (win && !win.closed) {
        win.location.replace(url);
        return;
      }
      window.open(url, "_blank", "noopener") || window.location.assign(url);
    },
    close() {
      if (win && !win.closed) win.close();
    },
  };
};
